export default __webpack_public_path__ + "static/media/CompletedPatient.37120ba3.svg";